const en = {
  title: 'Dashboard',
  welcome: 'Welcome to Rowen Inventory Management System',
  totalEquipment: 'Total Equipment',
  totalParts: 'Total Parts',
  quickActions: 'Quick Actions',
  manageEquipment: 'Manage Equipment',
  manageParts: 'Manage Parts',
  stockMovements: 'Stock Movements',
  recentItems: 'Recent Items',
  recentBrands: 'Recent Brands',
  recentCategories: 'Recent Categories',
  recentColors: 'Recent Colors',
};

const de = {
  title: 'Übersicht',
  welcome: 'Willkommen beim Rowen Inventarverwaltungssystem',
  totalEquipment: 'Ausrüstung gesamt',
  totalParts: 'Teile gesamt',
  quickActions: 'Schnellzugriff',
  manageEquipment: 'Ausrüstung verwalten',
  manageParts: 'Teile verwalten',
  stockMovements: 'Lagerbewegungen',
  recentItems: 'Letzte Einträge',
  recentBrands: 'Letzte Marken',
  recentCategories: 'Letzte Kategorien',
  recentColors: 'Letzte Farben',
};

const dashboard = { en, de };
export default dashboard;
